module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "owl-carousel"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [(item.img) ? _c('div', {
      staticClass: "topBlock",
      style: (("background-image: url(" + (item.img) + ");"))
    }, [(item.preloader) ? _c('img', {
      attrs: {
        "src": item.preloader,
        "alt": ""
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.video) ? _c('a', {
      staticClass: "topBlock video",
      style: (("background-image: url(" + (item.video.img) + ")")),
      attrs: {
        "data-fancybox": "",
        "href": item.video.href
      }
    }) : _vm._e(), _vm._v(" "), (item.description) ? _c('div', {
      staticClass: "description"
    }, [_vm._v("\n\t\t\t" + _vm._s(item.description) + "\n\t\t")]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8122e11c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/detailPhoto.vue
// module id = 282
// module chunks = 37